<template>
    <div
        class="three-columns-layout"
        :style="{'grid-template-columns': `${column1Width} ${column2Width} ${column3Width}`}">

        <!-- Column-1 -->
        <div class="column-panel category-column">
            <div class="column-title">
                <slot name="column-1-title" />
            </div>
            <div class="column-body">
                <div class="scroll-view">
                    <slot name="column-1-body" />
                </div>
            </div>
        </div>

        <!-- Column-2 -->
        <div class="column-panel group-column">
            <div class="column-title">
                <slot name="column-2-title" />
            </div>
            <div class="column-body">
                <div class="scroll-view">
                    <slot name="column-2-body" />
                </div>
            </div>
        </div>

        <!-- Column-3 -->
        <div class="column-panel item-column">
            <div class="column-title">
                <slot name="column-3-title" />
            </div>
            <div class="column-body">
                <div class="scroll-view">
                    <slot name="column-3-body" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        column1Width: {
            type: String,
            default: '130px',
        },
        column2Width: {
            type: String,
            default: '1fr',
        },
        column3Width: {
            type: String,
            default: '1fr',
        },
    },
};
</script>
<style lang="scss">
.three-columns-layout {
    display: grid;
    width: 100%;
    grid-template-columns: 130px 1fr 1fr;
    gap: 5px;
    margin-top: 10px;
    font-size: 10pt;

    .column-panel {
        background-color: #fff;
        border-radius: 10px;
        border: 1px solid #e7e7e7;
    }

    .column-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        height: 44px;
        color: #666;
        font-size: 10.5pt;
        font-weight: bold;
        background-color: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom: 1px solid #e7e7e7;
    }

    .column-body {
        height: calc(100vh - 230px);

        > .scroll-view {
            height: calc(100vh - 230px);
            overflow: auto;
            padding: 12px 12px 50px 12px;
        }
        .column-body-footer {
            padding: 10px 0;
        }
    }
}
</style>
